<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Change Target Type - {{this.aligner.serialNumber}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select
          v-model="selectedTargetType"
          label="Target Type?"
          outlined
          :items="targetTypes"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn :disabled="!selectedTargetType" color="blue" @click="onChangeClick()">Change</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    aligner: Object,
  },

  data() {
    return {
      selectedTargetType: null,
      targetTypes: ['AT200', 'AT700'],
    };
  },

  methods: {
    onChangeClick() {
      this.$emit('close', { serialNumber: this.aligner.serialNumber, selectedTargetType: this.selectedTargetType });
      this.selectedTargetType = null;
    },

    onCancelClick() {
      this.$emit('close', { });
      this.selectedTargetType = null;
    },
  },
};
</script>
